export const createProductVariationDropdown = ($element) => {
  const instance = {
    $element: null,
    changeHandlers: [],
    init: function (element) {
      this.$element = element;
      this.setEventHandlers();
    },
    setEventHandlers: function () {
      jQuery(".variations_form").on("wc_variation_form", () => {
        jQuery(".variations_form").on("found_variation", (event, variation) => {
          this.changeHandlers.forEach((handler) => handler(event, variation));
        });
      });
    },
    addChangeHandler: function (callback) {
      this.changeHandlers.push(callback);
    },
    getValue: function () {
      return this.$element.val();
    },
  };

  instance.init($element);
  return instance;
};
